import React from 'react';
import { useAuth } from './context/AuthProvider';
import { Routes, Route } from 'react-router-dom';
import { LoadingModal } from './shared/components/loader';
import PublicRouter from './app/Public.router';
import { AuthenticatedRoute } from './shared/components/routes/AuthenticatedRoute';
import { AdministratorRoute } from './shared/components/routes/AdministratorRoute';

const AuthenticatedRouter = React.lazy(
  () => import('./app/Authenticated.router'),
);
const AdministratorRouter = React.lazy(() => import('./app/Admin.router'));

function App() {
  const { isAuthenticated, isAdministrator } = useAuth();

  return (
    <React.Suspense fallback={<LoadingModal isLoading={true} />}>
      <Routes>
        <Route path='/*' element={<PublicRouter />} />
        {isAuthenticated ? (
          isAdministrator ? (
            <Route
              path='/administrator/*'
              element={
                <AdministratorRoute>
                  <AdministratorRouter />
                </AdministratorRoute>
              }
            />
          ) : (
            <Route
              path='/admin/*'
              element={
                <AuthenticatedRoute>
                  <AuthenticatedRouter />
                </AuthenticatedRoute>
              }
            />
          )
        ) : null}
      </Routes>
    </React.Suspense>
  );
}

export default App;
